module.exports = __webpack_public_path__ + "static/andreas-504c889aab71604628d702f32eebc311.png";